<template>
  <label class="checkbox-label">
    <p v-html="label"></p>
    <input type="checkbox" @click="onClick()" :checked="value" :disabled="disabled" />
    <span :class="IsRadio?'radio-checkmark':'checkbox-checkmark'" :style="style"></span>
  </label>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    label: {
      type: String,
      default: "label"
    },
    value: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    IsRadio: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      style: {
        "background-color": `#eee !important`
      }
    };
  },
  mounted: function() {
    this.$el.indeterminate = true;
  },
  watch: {
    value: function(newVal) {
      if (newVal) this.style = { "background-color": "#3862eb !important" };
      else
        this.style = {
          "background-color": `#eee !important`
        };
    }
  },
  methods: {
    onClick() {
      switch (this.value) {
        case false:
        case null:
          this.$emit("change", true);
          this.$emit("input", true);
          break;
        case true:
          this.$emit("change", false);
          this.$emit("input", false);
          break;
      }
    }
  }
};
</script>